import { render, staticRenderFns } from "./FileSaveConfig.vue?vue&type=template&id=ce181a78&scoped=true"
import script from "./FileSaveConfig.vue?vue&type=script&lang=ts"
export * from "./FileSaveConfig.vue?vue&type=script&lang=ts"
import style0 from "./FileSaveConfig.vue?vue&type=style&index=0&id=ce181a78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce181a78",
  null
  
)

export default component.exports